import { Avatar } from "@heroui/react";
import { UsersEntity } from '@bitecritic-api/src/users/users.zod';
import { BaseLink } from "../Link";
import { ROUTES } from "~/constants/routes.contants";
interface UserAvatarProps {
  user: UsersEntity;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  onClick?: () => void;
}

export function UserAvatar({ user, size = 'md', onClick }: UserAvatarProps) {
  const getInitials = (firstName?: string | null, lastName?: string | null) => {
    if (!firstName && !lastName) return user.username?.slice(0, 2).toUpperCase();
    return `${firstName?.[0] || ''}${lastName?.[0] || ''}`.toUpperCase();
  };

  return (
    <Avatar
      name={getInitials(user.firstName, user.lastName)}
      src={user.profilePictureUrl || undefined}
      size={size}
      onPress={onClick}
      isBordered
      color="secondary"
      as={BaseLink}
      href={`${ROUTES.USERS}/${user.username}`}
    />
  );
} 